const TYPES = {
  OPERATION: {
    'id': 1,
    'description': 'Operação',
  },
};

module.exports = {
  TYPES
}